import React, { useEffect } from 'react'
import { Row, Col, Button } from 'antd'
import Widget from 'components/Widget'
import heartIcon from 'assets/images/heart_icon.png'
import weightIcon from 'assets/images/weight_icon.png'
import bmiIcon from 'assets/images/body_mass_index_icon.png'
import bloodSugarIcon from 'assets/images/bllod_sugar_icon.png'
import IconWithTextCard from "components/IconWithTextCard";
import MonthlyAnalysis from './components/MonthlyAnalysis'
import IntlMessages from "util/IntlMessages"
import RecentActivities from 'components/ActivitiesList'


import dummyImage from 'assets/images/dummyImage.jpeg'
import moment from 'moment'
import { DataGetAction } from 'redux/actions/http'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { logoutFn } from 'redux/actions/Common'
const Index = () => {


    const styles = {
        profileImg: {
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            objectFit: 'cover'
        }
    }


    const history = useHistory()
    const dispatch = useDispatch();
    const patientProps = useSelector(state => state.clientDashboard)
    const { DailyRecord, PlaneUnSubscribePlane } = patientProps;
    const { age, bpDiastolic, bpSystolic, firstName, lastName, gender, profileImage, weight, bloodSugar, height, createdAt, planInfo, reportInfo, dailyBaseLine } = patientProps && patientProps.patientInfo.length && patientProps.patientInfo[0]

    
    const { planPrice, memberShipPlan } = patientProps && patientProps.patientInfo.length && planInfo && planInfo.length && planInfo[0];

    console.log('======details======', patientProps && patientProps.patientInfo.length && patientProps.patientInfo[0])

    const fetchPatientData = () => {
        dispatch(DataGetAction('getPatientInfo', '', 'gettingPatientInfo'))
        dispatch(DataGetAction('getDailyOverview', '', 'gettingDailyOverview'))
    }

    useEffect(fetchPatientData, [])

    // const fetchAfterUnsubscribe = () => {
    //     if (PlaneUnSubscribePlane) {
    //         dispatch(DataGetAction('getPatientInfo', '', 'gettingPatientInfo'))
    //         dispatch(DataGetAction('getDailyOverview', '', 'gettingDailyOverview'));
    //         dispatch({
    //             type: 'reset_unsubscribe'
    //         })
    //     }

    // }
    // useEffect(fetchAfterUnsubscribe, [PlaneUnSubscribePlane])


    if (PlaneUnSubscribePlane) {
        console.log("============ PlaneUnSubscribePlane", PlaneUnSubscribePlane);
        dispatch(DataGetAction('logout', '', 'loggingOut'));
        dispatch(logoutFn());
        history.push('/')
        dispatch({
            type: 'update_auth'
        });

        dispatch({
            type: 'reset_unsubscribe'
        })

    }



    const calculateBMI = () => {
        if (height && weight) {
            let clientWeight = +weight
            let clientHeight = +height
            const bmi = (clientWeight) / (clientHeight * clientHeight)

            return bmi.toFixed(2)
        }
        else {
            return 0
        }
    }

    const redirectToSubscription = () => {
        history.push({
            pathname: '/subscription',
            query: 'alreadyFreeUser'
        })
    }


    const renderRedFlagCount = () => {



        let count = 0;
        console.log("====== patientProps.reportInfo ======", reportInfo)
        if (reportInfo && reportInfo.length > 0) {
            let redFlags = reportInfo[0].redFlags;
            if (redFlags.length > 0) {
                redFlags.forEach(Item => {
                    let selected = (Item.selected && Item.selected.length) || 0;
                    count = count + selected
                })
            }

            if (reportInfo && reportInfo[0].dailyUpdate.length > 0) {
                reportInfo[0].dailyUpdate.forEach((Item, index) => {
                    if (Item.selected[0] !== dailyBaseLine[index].selected[0]) {
                        count = count + 1
                    }
                })
            }
        }




        return count
    }

    const renderUserId = () => {
        const userData = JSON.parse(localStorage.getItem('userInfo'));
        if (userData) {
            const { userId } = userData && userData
            return <div className="gx-mb-2"> <span className=" gx-mr-2">Id:</span> <span className="gx-text-black">{userId && userId}</span></div>
        }
    }

    const renderPlan = () => {
        if (memberShipPlan === 'free') {
            return <>
                <h4 className="gx-d-block gx-mb-2 gx-mt-2">Free</h4>
                <Button type="primary" className="gx-pt-0 gx-mb-0" onClick={() => { redirectToSubscription() }}>Update Plan</Button>
            </>
        }
        else if (memberShipPlan === "noPlan") {
            return <>
                <h4 className="gx-d-block gx-mb-2 gx-mt-2">No Plan</h4>
            </>
        }
        else if (memberShipPlan !== 'free') {
            return <>
                <h4 className="gx-mb-2 gx-mt-2">USD {planPrice}  <small>/month</small></h4>
                {/* <RenewPlan renewalDate={renewalDate} /> */}
            </>
        }
    }


    return (
        <Row>
            <Col xl={18} lg={16} md={16} sm={24} xs={24}>
                <Widget title={<h4 className="gx-font-sans-bold gx-text-capitalize gx-blue-font">welcome {firstName} {lastName}!</h4>}>
                    <div className="gx-d-flex">
                        <div className="gx-w-75 gx-d-flex gx-justify-content-between gx-pr-5 gx-border-right">
                            <div className="gx-mr-3">

                                {profileImage ? <img style={styles.profileImg} src={profileImage} alt="" /> : <img style={styles.profileImg} src={dummyImage} alt="" />}
                            </div>
                            <div className="gx-d-flex gx-flex-column">
                                <div className="gx-mb-2"> <span className="icon icon-feedback gx-mr-2 "></span> <span >Updates</span>  </div>
                                <div className="gx-mb-2"> <span className="icon icon-chat-bubble gx-mr-2 gx-mb-2"></span> <span>{renderRedFlagCount()} Red Flags</span></div>
                            </div>
                            <div className="gx-flex-column ">
                                <div className="gx-mb-2"> <span className="gx-mr-2">Sex:</span> <span className="gx-text-black">{gender}</span>  </div>
                                <div className="gx-mb-2"> <span className=" gx-mr-2">Age:</span> <span className="gx-text-black">{age}</span></div>
                                <div className="gx-mb-2"> <span className=" gx-mr-2">Check in:</span> <span className="gx-text-black">{moment(createdAt).format('DD MMM, YYYY')}</span></div>
                                {renderUserId()}
                            </div>
                        </div>
                        <div className="gx-w-25 gx-py-3 gx-px-3">
                            <div>
                                <span>Your current plan</span>
                                {renderPlan()}
                                {/* {memberShipPlan && memberShipPlan === 'free' ? <h4 className="gx-d-block gx-mb-2 gx-mt-2">Free</h4> : <h4 className="gx-mb-2 gx-mt-2">USD {planPrice}  <small>/month</small></h4>}


                                {memberShipPlan && memberShipPlan !== 'free' ? <RenewPlan renewalDate={renewalDate} /> :
                                    <Button type="primary" className="gx-pt-0 gx-mb-0" onClick={() => { redirectToSubscription() }}>Update Plan</Button>} */}


                            </div>
                        </div>
                    </div>
                </Widget>
                <Row>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                        <IconWithTextCard cardColor="cyan" icon={heartIcon} title={`${bpSystolic || 0} | ${bpDiastolic || 0}`} subTitle="Blood pressure" />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                        <IconWithTextCard cardColor="orange" icon={bloodSugarIcon} title={bloodSugar || 0} subTitle="Blood sugar" />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                        <IconWithTextCard cardColor="teal" icon={weightIcon} title={weight || 0} subTitle="Weight (pounds)" />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                        <IconWithTextCard cardColor="red" icon={bmiIcon} title={calculateBMI()} subTitle="Body mass index" />
                    </Col>
                </Row>
                <Row>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <MonthlyAnalysis data={DailyRecord} title={<IntlMessages id="dashboard.client.monthlyHealthReport" />} width={'100%'} height={180} axisX={'name'} axisY={['RedFlags']} showYAxis={true} />
                    </Col>
                </Row>
            </Col>
            <Col xl={6} lg={8} md={8} sm={24} xs={24}>
                <div className="recent-activity-container">
                    <RecentActivities showImage={false} title={<IntlMessages id="dashboard.client.recentActivities" />} />
                </div>
            </Col>
        </Row>
    )
}

export default Index
